import React from 'react';
// import pure from 'recompose/pure';
import SvgIcon from 'material-ui/SvgIcon';

let IconUpload = (props) => {
  props = Object.assign({viewBox: '0 0 48 48'}, props);
  return (
    <SvgIcon {...props}>
      <g>
        <path d="M25.3,16.4v9.4v2.4v4.5h-2.6v-4.5v-2.4v-9.4L25.3,16.4z"/>
      </g>
      <g>
        <path d="M25.9,17.1l6.4,6.4l-1.7,1.7l-6.4-6.4l-6.7,6.7l-1.8-1.8l6.7-6.7l1.7-1.7L25.9,17.1z"/>
      </g>
      <path d="M24.4,43.7c-10.9,0-19.8-8.9-19.8-19.8S13.5,4.1,24.4,4.1S44.2,13,44.2,23.9S35.3,43.7,24.4,43.7z M24.4,6.1c-9.8,0-17.8,8-17.8,17.8s8,17.8,17.8,17.8s17.8-8,17.8-17.8S34.2,6.1,24.4,6.1z"/>
    </SvgIcon>
  );
};
// IconUpload = pure(IconUpload);
IconUpload.displayName = 'IconUpload';
IconUpload.muiName = 'SvgIcon';

export default IconUpload;



// WEBPACK FOOTER //
// ./src/components/Icons/IconUpload.js